module.exports = __webpack_public_path__ + "static/media/home-mask.f181a963.png";